/** App deployment environment: local | development | demo | production */
export type AppEnv = "local" | "development" | "demo" | "production";

function envFromVite(): AppEnv | null {
  const raw = import.meta.env.VITE_APP_ENV?.trim().toLowerCase();
  if (raw === "local" || raw === "development" || raw === "demo" || raw === "production") {
    return raw;
  }
  return null;
}

function envFromHostname(): AppEnv | null {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname;
  if (host === "demo.konstrulog.com" || host.startsWith("demo.")) return "demo";
  if (host === "app.konstrulog.com" || host === "admin.konstrulog.com") {
    return "production";
  }
  if (host === "dev.konstrulog.com" || host.startsWith("dev.")) {
    return "development";
  }
  if (host === "localhost" || host === "127.0.0.1") return "local";
  return null;
}

export function getAppEnv(): AppEnv {
  return envFromVite() ?? envFromHostname() ?? "local";
}

export function isDemoEnv(): boolean {
  return getAppEnv() === "demo";
}

export function isDevelopmentEnv(): boolean {
  return getAppEnv() === "development";
}
